const SaleRefundErrorEnum = Object.freeze({
  SALE_REFUND_WINDOW_EXPIRED: 'SALE_REFUND_WINDOW_EXPIRED',
  SALE_NOT_REFUNDABLE: 'SALE_NOT_REFUNDABLE',
  SALE_ALREADY_REFUNDED: 'SALE_ALREADY_REFUNDED',
});

// The back sends `error.message` in English (eng-docs error-handling Rule 1),
// so the copy shown in the ERP comes from this map, keyed by `error.code`.
const SALE_REFUND_ERROR_MESSAGES = Object.freeze({
  [SaleRefundErrorEnum.SALE_REFUND_WINDOW_EXPIRED]:
    'Reembolso recusado: a venda foi paga há mais de 90 dias e está fora do prazo de reembolso.',
  [SaleRefundErrorEnum.SALE_NOT_REFUNDABLE]:
    'Reembolso recusado: só é possível reembolsar vendas pagas.',
  [SaleRefundErrorEnum.SALE_ALREADY_REFUNDED]:
    'Esta venda já foi reembolsada ou já tem um reembolso em andamento.',
});

/**
 * Resolves a server-supplied error code to its pt-BR copy.
 * Unknown, malformed or inherited (`__proto__`, `toString`) codes return null,
 * so the caller falls back to the server's own message.
 *
 * @param {*} code - raw `error.code` value from the API response.
 * @returns {string|null}
 */
function resolveSaleRefundErrorMessage(code) {
  if (typeof code !== 'string') return null;
  if (!Object.prototype.hasOwnProperty.call(SALE_REFUND_ERROR_MESSAGES, code)) {
    return null;
  }
  const message = SALE_REFUND_ERROR_MESSAGES[code];
  return typeof message === 'string' ? message : null;
}

export { SaleRefundErrorEnum, SALE_REFUND_ERROR_MESSAGES, resolveSaleRefundErrorMessage };
